import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import SelectableButton from '../selectable-button/SelectableButton'
import { Tooltip, TooltipProps } from '../../../../atoms'

interface TooltipButtonProps {
  label: string
  isSelected: boolean
  onClick: () => void
  isDisabled?: boolean
  tooltipProps?: Pick<TooltipProps, 'content' | 'disable' | 'position'>
}

const TooltipButton: React.FC<TooltipButtonProps> = ({
  label,
  isDisabled = false,
  isSelected,
  onClick,
  tooltipProps,
}) => {
  const button = (
    <SelectableButton
      isDisabled={isDisabled}
      onClick={onClick}
      isSelected={isSelected}
      content={
        <span className={clsx(s.label, { [s.labelSelected]: isSelected })}>
          {label}
        </span>
      }
    />
  )

  if (tooltipProps) {
    return (
      <Tooltip {...tooltipProps} contentClassName={s.tooltip}>
        {button}
      </Tooltip>
    )
  }

  return <div>{button}</div>
}

export default TooltipButton
